import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import { useRouter } from "next/router";

export default function BreadcrumbsAuto({
	breadcrumb_color = "codebee_grey.main",
	shop_mode = false,
}) {
	const height = "40px";

	const router = useRouter();

	const { pathname } = router;

	const pathSections = pathname
		.split("/")
		.filter((v) => v)
		.map((v) => {
			if (v.startsWith("[")) {
				const key = v.replace("[", "").replace("]", "");
				return router.query[key];
			}
			return v;
		})
		.filter((v) => v); // Filter out the empty strings

	function sanitizeLabel(str) {
		const joinedString = str.charAt(0).toUpperCase() + str.slice(1);
		return joinedString.replace(/-/g, " ");
	}

	function createUrlLink(list, index) {
		if (index < 0 || index >= list.length) {
			return "/";
		}
		const breadcrumbURL = list.slice(0, index + 1).join("/");
		return `/${breadcrumbURL}`;
	}

	return (
		<Box sx={{ alignItems: "center", display: "flex", height: height }}>
			<Breadcrumbs
				aria-label="breadcrumb"
				separator={
					<NavigateNextIcon
						sx={{
							color: breadcrumb_color,
							fontSize: { md: "18px", xs: "16px" },
						}}
						fontSize="small"
					/>
				}
			>
				<Link href={shop_mode ? "/shop" : "/"} passHref>
					<Box display="flex" justifyContent="center" alignItems="center">
						<HomeIcon
							sx={{ color: breadcrumb_color, fontSize: { md: "18px", xs: "16px" }, mr: 0.25 }}
						/>
						<Typography sx={{ fontSize: { md: "16px", xs: "14px" } }} color={breadcrumb_color}>
							{sanitizeLabel("Home")}
						</Typography>
					</Box>
				</Link>

				{pathSections.map((v, i) => {
					if (i !== pathSections.length - 1) {
						return (
							<Link href={createUrlLink(pathSections, i)} key={i} passHref>
								<Typography
									sx={{ fontSize: { md: "16px", xs: "14px" } }}
									color="codebee_blue.light"
								>
									{sanitizeLabel(v)}
								</Typography>
							</Link>
						);
					}

					return (
						<Typography
							sx={{ fontSize: { md: "16px", xs: "14px" } }}
							color={breadcrumb_color}
							key={i}
						>
							{sanitizeLabel(v)}
						</Typography>
					);
				})}
			</Breadcrumbs>
		</Box>
	);
}
